import React, { useEffect, useState } from 'react';
import {useFetch} from '@utils'
import { Spin, message, Button, Typography, List } from 'antd';
import { LarpTable } from '@tables';
import TextEditorReadOnly from '../../../text/TextEditorReadOnly';
import PotionWikiModal from '../modal/PotionWikiModal';
import { PotionWikiCsv } from './cvs';
import { sortByString } from '../../../../utils/functions/Sorters';
const { Text } = Typography;

export default function PotionWiki() {
     const [doFetch] = useFetch();
     const[isLoading, setIsLoading] = useState(true)
     const [searchValue, setSearchValue] = useState("");
     const [dataSource, setDataSource] = useState([]);
     const [listSource, setListSource] = useState([]);
     const [result, setResult] = useState([])
     const [isModalVisible, setIsModalVisible] = useState(false);
     const [selectedRecord, setSelectedRecord] = useState(undefined);
     const [amountShown, setAmountShown] = useState(0);

      useEffect(() => {
        if(result.length <= 0) {
          return;
        }
        const newDataSource = result.filter(_ => {
             return _.item?.name?.toLowerCase().includes(searchValue.toLowerCase())
          || _.herbType?.name?.toLowerCase().includes(searchValue.toLocaleLowerCase())
          || _.id.toString().includes(searchValue.toString())
          || _.item?.id.toString().includes(searchValue.toString())
        }

        )
        setDataSource(newDataSource);
        setListSource(tableList(newDataSource, onRowClick))
        setAmountShown(newDataSource.length)
      }, [result, searchValue])

      useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [searchValue])

      function refresh(id)
      {
          const url = `/api/potion/getwiki`
          doFetch(url)
          .then((response) => onLoaded(response.isSuccess, response.result))
  
          function onLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              setIsLoading(false);

              if(id !== undefined) {
                const found = result.find(_ => _.id === id)
                if(found !== undefined) {
                  setSelectedRecord(found);
                  setIsModalVisible(true)
                }
              }
              return;
            }
            setResult([])
            message.error('Could not get potions');
            setIsLoading(false);
          }
      }

      if(isLoading)
      {
          return <Spin />
      }

      function onRowClick(record)
      {
        setSelectedRecord(record);
        setIsModalVisible(true);
      }

      const columns = [
        {
          title: 'Id',
          dataIndex: 'id',
          key: 'id',
          hidden: true,
        },
        {
            title: 'Item Id',
            key: 'itemId',            
            render: (record) => {
                return record.item?.id
              },
            sorter: (a, b) => a.item?.id - b.item?.id,
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
        {
            title: 'Name',
            key: 'name',            
            render: (record) => {
                return record.item?.name
              },
            sorter: (a, b) => sortByString(a.item?.name, b.item?.name),
            sortDirections: ['ascend', 'descend', 'ascend'],
              
        },
        {
            title: 'Description',
            key: 'description',
            render: (record) => {
               return (<TextEditorReadOnly content={record.item?.description}/>)
             },
        },
        {
          title: 'Action',
          key: 'action', 
          render: (record) => {
            return(

              // <Popconfirm title="Sure to delete?" onConfirm={() => onDelete(record)}>
              //  {/*eslint-disable-next-line*/}
              //     <a>Delete</a>
              // </Popconfirm>
              <>

                <Button type="text" onClick={() => onRowClick(record)}>View</Button>
              </>
          
          )
          }
        }
    ].filter(_ => !_.hidden)

    function onTableChange(pagination, filters, sorter, extra)
    {
      setAmountShown(extra.currentDataSource.length)
    }

    return (
      <>

        <Text>{amountShown} of {result.length} potions shown </Text>
        <LarpTable 
          setSearchValue={setSearchValue}
          refresh={refresh}
          onDoubleRowClick={onRowClick}
          dataSource={dataSource}
          listSource={listSource}
          columns={columns}
          onTableChange={onTableChange}
          csv={PotionWikiCsv(dataSource)}
        />
        
        {isModalVisible && <PotionWikiModal 
          refresh={refresh}
          setIsModalVisible={setIsModalVisible}
          isModalVisible={isModalVisible}
          record={selectedRecord}
        />} 
      </>
    )
}

export function tableList(  
  list,   
  onRowClick,
) {
  return list.map(_ => {
    return (
            <List.Item
              style={{display:"flex", flexDirection:"column"}}
              onClick={() => onRowClick(_)}
            >

              <List.Item.Meta
                style={{width:"100%"}}
                title={_.item?.name}
                description={`Item id: ${_.item?.id}`}
              />
                <TextEditorReadOnly content={_.item?.description}/>
            </List.Item>
    )
  })
}